<template>
    <div class="plugin_index">
        <div class="plugin_index_title"></div>
        <div class="plugin_index_box">
            <div>网站右侧面板</div>
            <el-switch v-model="index_from.right_ban" active-color="#3581FE" inactive-color="#DCDFE6" @change="switchChange"></el-switch>
        </div>
        <div class="plugin_index_box">
            <div>搜索结果标记</div>
            <el-switch v-model="index_from.select_biao" active-color="#3581FE" inactive-color="#DCDFE6" @change="switchChange"></el-switch>
        </div>
        <div class="plugin_index_box">
            <div>页面公司标记</div>
            <el-switch v-model="index_from.page_biao" active-color="#3581FE" inactive-color="#DCDFE6" @change="switchChange"></el-switch>
        </div>
        <div class="plugin_index_box">
            <div>鼠标划词标记</div>
            <el-switch v-model="index_from.mouse_biao" active-color="#3581FE" inactive-color="#DCDFE6" @change="switchChange"></el-switch>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            index_from:{
                right_ban:true,
                select_biao:true,
                page_biao:true,
                mouse_biao:true
            }
        }
    },
    methods:{
        switchChange(){
            // console.log(this.index_from);
            window.parent.postMessage({
                funName:'setType',
                obj:{
                    right_ban:this.index_from.right_ban == true? 1:0,
                    select_biao:this.index_from.select_biao == true? 1:0,
                    page_biao:this.index_from.page_biao == true? 1:0,
                    mouse_biao:this.index_from.mouse_biao == true? 1:0
                }
            },'*')
        }
    },
    mounted(){
        var cc = JSON.parse(this.$route.query.indexData);
        this.index_from = {
            right_ban:cc.right_ban == 1? true:false,
            select_biao:cc.select_biao == 1? true:false,
            page_biao:cc.page_biao == 1? true:false,
            mouse_biao:cc.mouse_biao == 1? true:false
        }
        console.log(this.index_from)
    }
}
</script>
<style lang="scss" scoped>
.plugin_index{
    width: 100%;
    height: auto;
    background-color: #F4F7F9;
    padding-bottom: 15px;
}
.plugin_index_title{
    width: 100%;
    height: 57px;
    background-color: #3581FE;
    background-image: url('https://zyprogram.xinchacha.com/plugin/logo.png');
    background-repeat: no-repeat;
    background-size: auto 47px;
    background-position: 50% 50%;
}

.plugin_index_box{
    width: 92%;
    height: 40px;
    background: #FFFFFF;
    border-radius: 4px;
    font-size: 16px;
    color: #333333;
    font-weight: 400;
    display: flex;
    align-items: center;
    margin: 15px auto 0;
    padding-left: 14px;
    padding-right: 14px;
    box-sizing: border-box;
    justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/components/plugin_unit_index.vue